import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=4537185b&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=4537185b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537185b",
  null
  
)

export default component.exports